// @flow
import { handleResponseOld, makeGet, makePost } from './helpers';

type FetchConversationMessagesParams = {
    authToken: string,
    bidderId: number,
    conversationId: number,
    deployment: string,
};

type SendConversationMessageParams = {
    attachedFiles: any[],
    authToken: string,
    bidderId: number,
    conversationId: number,
    deployment: string,
    messageBody: any,
};

export default {
    fetchConversationMessages: ({ authToken, bidderId, conversationId, deployment }: FetchConversationMessagesParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({
                authToken,
                deployment,
                path: `<MESSAGING-API>bidders/${bidderId}/messages`,
            });
            request.query({ conversationId });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    sendConversationMessage: ({
        attachedFiles = [],
        authToken,
        bidderId,
        conversationId,
        deployment,
        messageBody,
    }: SendConversationMessageParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                authToken,
                deployment,
                path: `<MESSAGING-API>bidders/${bidderId}/messages`,
            });
            attachedFiles.forEach(file => {
                request.attach(file.name, file);
            });
            request.query({ conversationId });
            request.field('message', JSON.stringify({ messageBody }));
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
